import Vue from 'vue'

const COMMON = new Vue();

export default COMMON


// WEBPACK FOOTER //
// ./src/assets/js/common.js